export class NotContainsNumberError extends Error {
  constructor () {
    super('O campo deve ter ao menos um número')
    this.name = 'NotContainsNumberError'
  }
}
